// @flow
import React, { PureComponent } from 'react';
import { View } from 'react-native';

class DeliveryStatusBar extends PureComponent<Props> {
  render() {
    const style: Object = {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    };
    const barStyle = {
      position: 'absolute',
      height: 6,
      backgroundColor: this.props.backgroundColor,
      right: 0,
      left: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      zIndex: 0,
    };
    if (this.props.side === 'left') {
      barStyle.borderTopLeftRadius = 5;
      barStyle.borderBottomLeftRadius = 5;
    } else {
      barStyle.borderTopRightRadius = 5;
      barStyle.borderBottomRightRadius = 5;
      style.justifyContent = 'space-between';
    }

    return (
      <View style={style}>
        <View style={barStyle} />
        {this.props.children}
      </View>
    );
  }
}
type Props = {
  side: 'left' | 'right',
  backgroundColor: string,
  children?: any,
};

export default DeliveryStatusBar;
